<script>
  // This component was originally created to enable height and width animations based on the
  // dimensions of the slotted content, but animating the width has proven difficult
  // (and probably not a good idea for performance). We have tried two methods, with mixed results:
  // 1) Double parking the `<slot />` so we have a "clone" whose `clientWidth` we bind to, and
  // then use that for setting the `.container` width in an inline style. This works, but the
  // obvious drawback is that things are added to the DOM twice - in practice, this lead to failed
  // tests because elements that weren't supposed to be on the page were.
  // 2) Nesting the `.measurement` element inside the `.container`, measuring its `clientWidth`,
  // and applying that to the container. The problem with this is that the container constrains
  // the width of the inner element, preventing it from growing. To mitigate this, we can always
  // add to the inner element's `clientWidth` a buffer (e.g. 10px) to allow it to resize, but this
  // results in a loop of (inner grows -> outer grows -> inner grows -> ...) that only stops if you
  // set a max width in code. The drawback of this is that the Expandable will always be an
  // additional `buffer` size up to the max width. The smaller the buffer size, the longer the
  // resizing loop. The larger the buffer size, the more empty space alongside the slotted content.
  //
  // Neither of the above solutions were preferable, so this component no longer animates
  // the width resizing. The height resizing seems fine though.
  let clientHeight = 0;
  $: style = `height: ${clientHeight}px;`;
</script>

<div class='container' {style}>
  <div class='measurement' bind:clientHeight>
    <slot />
  </div>
</div>


<style>
  .container {
    position: relative;
    overflow: hidden;
    transition: var(--duration--fast);
  }
</style>
